import { CloseOutlined } from '@mui/icons-material';
import { Hide } from '@on3/ui-lib/components/Hide';
import { useClickOutside } from '@on3/ui-lib/hooks/useClickOutside';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';

import styles from './Modal.module.scss';

export type ModalSize = 'default' | 'sm' | 'md' | 'lg' | 'xl' | 'screen';

interface IModalBase {
  show: boolean;
  close: () => void;
  required?: boolean;
  size?: ModalSize;
  children: React.ReactNode;
}

export const ModalBase = ({
  show,
  close,
  required = false,
  size = 'default',
  children,
}: IModalBase) => {
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref, close, required);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div
          className={clsx(styles.modal, {
            [styles.sm]: size === 'sm',
            [styles.md]: size === 'md',
            [styles.lg]: size === 'lg',
            [styles.xl]: size === 'xl',
            [styles.screen]: size === 'screen',
          })}
          ref={ref}
        >
          {!required && (
            <button className={styles.close} onClick={close}>
              <span className="sr-only">close</span>
              <CloseOutlined />
            </button>
          )}
          {children}
        </div>
      </div>
      <Hide classes={['.adthrive-ad', '.adhesionAd', '[data-gg-moat]']} />
    </div>
  );
};
